import {
  DataTableSkeleton,
  SkeletonPlaceholder,
  SkeletonText,
} from '@carbon/react';
import styles from './section-skeletons.module.scss';

export const AreaConfigsSkeleton = () => (
  <div className={styles.inputsGrid}>
    {Array.from({ length: 7 }).map((_, i) => (
      <SkeletonPlaceholder key={i} className={styles.fieldSkeleton} />
    ))}
  </div>
);

export const FormationsSkeleton = () => (
  <DataTableSkeleton
    columnCount={7}
    rowCount={4}
    showHeader={false}
    showToolbar={false}
  />
);

export const InventoryManagementSkeleton = () => (
  <>
    <SkeletonText className={styles.labelSkeleton} />
    <div className={styles.reorderListSkeleton}>
      {Array.from({ length: 3 }).map((_, i) => (
        <SkeletonPlaceholder key={i} className={styles.listItemSkeleton} />
      ))}
    </div>
  </>
);

export const TypeWellProfileSkeleton = () => (
  <>
    {Array.from({ length: 2 }).map((_, i) => (
      <div key={i} className={styles.typeWellRow}>
        <SkeletonPlaceholder className={styles.fieldSkeleton} />
        <SkeletonPlaceholder className={styles.fieldSkeleton} />
        <SkeletonPlaceholder className={styles.fieldSkeleton} />
        <SkeletonPlaceholder className={styles.dcaFieldSkeleton} />
        <SkeletonPlaceholder className={styles.radioFieldSkeleton} />
        <SkeletonPlaceholder className={styles.iconSkeleton} />
      </div>
    ))}
    <SkeletonPlaceholder className={styles.buttonSkeleton} />
  </>
);

export const ScalingConfigsSkeleton = () => (
  <>
    {Array.from({ length: 2 }).map((_, i) => (
      <div key={i} className={styles.scalingRow}>
        <SkeletonPlaceholder className={styles.fieldSkeleton} />
        <SkeletonPlaceholder className={styles.fieldSkeleton} />
        <SkeletonPlaceholder className={styles.fieldSkeleton} />
        <SkeletonPlaceholder className={styles.fieldSkeleton} />
        <SkeletonPlaceholder className={styles.iconSkeleton} />
      </div>
    ))}
    <SkeletonPlaceholder className={styles.buttonSkeleton} />
  </>
);

export const ValidationConfigsSkeleton = () => (
  <>
    {Array.from({ length: 2 }).map((_, i) => (
      <div key={i} className={styles.generalRuleRow}>
        <SkeletonPlaceholder className={styles.checkboxSkeleton} />
        <SkeletonPlaceholder className={styles.fieldSkeleton} />
        <SkeletonPlaceholder className={styles.fieldSkeleton} />
        <SkeletonPlaceholder className={styles.iconSkeleton} />
      </div>
    ))}
    <SkeletonPlaceholder className={styles.buttonSkeleton} />

    <SkeletonText className={styles.sectionHeadingSkeleton} />

    <div className={styles.streamThresholdRow}>
      <SkeletonPlaceholder className={styles.checkboxSkeleton} />
      <SkeletonPlaceholder className={styles.fieldSkeleton} />
      <SkeletonPlaceholder className={styles.fieldSkeleton} />
      <SkeletonPlaceholder className={styles.fieldSkeleton} />
      <SkeletonPlaceholder className={styles.fieldSkeleton} />
      <SkeletonPlaceholder className={styles.iconSkeleton} />
    </div>
    <SkeletonPlaceholder className={styles.buttonSkeleton} />
  </>
);
